<template>
  <div class="game-info">
    <div class="team-vs-score">
      <div class="home">
        <div class="logo">
          <div class="team-line" :class="{ 'home-red': isHomeRed && isHomeRed !== -1, 'home-blue': !isHomeRed && isHomeRed !== -1 }">
            <img :src="coverInfo.home_logo" @error="onCsgoTeamLogoError" alt="">
          </div>
        </div>
        <div class="score-wrap">
          <div class="score">{{ homeScore || 0 }}</div>
        </div>
      </div>
      <div class="time">第{{ coverInfo.game_count | numToCN }}局</div>
      <div class="away">
        <div class="score-wrap">
          <div class="score">{{ awayScore || 0 }}</div>
        </div>
        <div class="logo">
          <div class="team-line" :class="{'away-blue': isHomeRed && isHomeRed !== -1, 'away-red': !isHomeRed && isHomeRed !== -1 }">
            <img :src="coverInfo.away_logo" @error="onCsgoTeamLogoError" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="info-detail">
      <div class="left">
        <div class="info-item">
          <div class="home">
            <div class="num">{{ homeDestroyEnemy || 0 }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeDestroyEnemyRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">歼灭敌人</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awayDestroyEnemyRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ awayDestroyEnemy || 0 }}</div>
          </div>
        </div>
        <div class="info-item">
          <div class="home">
            <div class="num">{{ homeDetonateBomb || 0 }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeDetonateBombRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">引爆炸弹</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awayDetonateBombRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ awayDetonateBomb || 0 }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="info-item">
          <div class="home">
            <div class="num">{{ homeDefuseBomb || 0 }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeDefuseBombRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">拆除炸弹</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awayDefuseBombRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ awayDefuseBomb || 0 }}</div>
          </div>
        </div>
        <div class="info-item">
          <div class="home">
            <div class="num">{{ homeNoTime || 0 }}</div>
            <div class="line">
              <div class="active" :class="{ 'home-red-team-color': isHomeRed && isHomeRed !== -1, 'home-blue-team-color': !isHomeRed && isHomeRed !== -1 }"  :style="{width: homeNoTimeRange * 100 + '%'}"></div>
            </div>
          </div>
          <div class="title">时间耗尽</div>
          <div class="away">
            <div class="line">
              <div class="active" :class="{ 'away-blue-team-color': isHomeRed && isHomeRed !== -1, 'away-red-team-color': !isHomeRed && isHomeRed !== -1 }" :style="{width: awayNoTimeRange * 100 + '%'}"></div>
            </div>
            <div class="num">{{ awayNoTime || 0 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'CsgoGameInfo',
  props: {
    coverInfo: {
      type: Object
    },
    gameInfo: {
      type: Object
    }
  },
  filters: {
    numToCN(num) {
      // 定义一个数组存储汉字
      const CN_CHARS = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      // 定义一个字符串存储结果
      let result = "";
      // 定义一个变量存储位数
      let digit = 0;
      // 使用一个循环遍历数字的每一位
      while (num > 0) {
        // 取出数字的最后一位
        let last = num % 10;
        // 根据位数和值拼接汉字
        if (digit === 0) {
          // 个位
          result = CN_CHARS[last] + result;
        } else if (digit === 1) {
          // 十位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加十和对应的汉字
            result = "十" + CN_CHARS[last] + result;
          }
        } else if (digit === 2) {
          // 百位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加百和对应的汉字
            result = "百" + CN_CHARS[last] + result;
          }
        }
        // 将数字除以10，去掉最后一位
        num = Math.floor(num / 10);
        // 将位数加一
        digit++;
      }
      // 返回结果
      return result;
    },
    secToMin(sec) {
      // 将秒数除以60，得到分钟数
      let min = sec / 60;
      // 使用 Math.floor 方法向下取整
      min = Math.floor(min);
      const second = sec % 60 < 10 ? '0'  + sec % 60 : sec % 60
      // 返回结果
      return `${min}:${second}`;
    },
    formatNumber(num) {
      return num >= 1000 ? (num / 1000).toFixed(1) + 'k' : num;
    }
  },
  computed: {
    isHomeRed () {
      const side = this.gameInfo.home.team && this.gameInfo.home.team.first_side == 2 || 0
      return side
    },
    homeScore () {
      const count = this.gameInfo.home.team && (this.gameInfo.home.team.first_half_score + this.gameInfo.home.team.second_half_score + (this.gameInfo.home.team.overtime_score || 0)) || 0
      return count - 0
    },
    awayScore () {
      const count = this.gameInfo.away.team && (this.gameInfo.away.team.first_half_score + this.gameInfo.away.team.second_half_score + (this.gameInfo.away.team.overtime_score || 0)) || 0
      return count - 0
    },
    homeNoTime () {
      const money = this.gameInfo.home.team && this.gameInfo.home.team.no_time || 0
      return money - 0
    },
    awayNoTime () {
      const money = this.gameInfo.away.team && this.gameInfo.away.team.no_time || 0
      return money - 0
    },
    noTimeCount () {
      const homeCount = this.homeNoTime || 0
      const awayCount = this.awayNoTime || 0
      return homeCount + awayCount
    },
    homeNoTimeRange () {
      if (this.noTimeCount < 1) {
        return 0
      }
      return this.homeNoTime / this.noTimeCount
    },
    awayNoTimeRange () {
      if (this.noTimeCount < 1) {
        return 0
      }
      return this.awayNoTime / this.noTimeCount
    },
    homeDestroyEnemy () {
      const count = this.gameInfo.home.team && this.gameInfo.home.team.destroy_enemy || 0
      return count - 0
    },
    awayDestroyEnemy () {
      const count = this.gameInfo.away.team && this.gameInfo.away.team.destroy_enemy || 0
      return count - 0
    },
    destroyEnemyCount () {
      const homeCount = this.homeDestroyEnemy
      const awayCount = this.awayDestroyEnemy
      return homeCount + awayCount
    },
    homeDestroyEnemyRange () {
      if (this.destroyEnemyCount < 1) {
        return 0
      }
      return this.homeDestroyEnemy / this.destroyEnemyCount
    },
    awayDestroyEnemyRange () {
      if (this.destroyEnemyCount < 1) {
        return 0
      }
      return this.awayDestroyEnemy / this.destroyEnemyCount
    },
    homeDetonateBomb () {
      const count = this.gameInfo.home.team && this.gameInfo.home.team.detonate_bomb || 0
      return count - 0
    },
    awayDetonateBomb () {
      const count = this.gameInfo.away.team && this.gameInfo.away.team.detonate_bomb || 0
      return count - 0
    },
    detonateBombCount () {
      const homeCount = this.homeDetonateBomb || 0
      const awayCount = this.awayDetonateBomb || 0
      return homeCount + awayCount
    },
    homeDetonateBombRange () {
      if (this.detonateBombCount < 1) {
        return 0
      }
      return this.homeDetonateBomb / this.detonateBombCount
    },
    awayDetonateBombRange () {
      if (this.detonateBombCount < 1) {
        return 0
      }
      return this.awayDetonateBomb / this.detonateBombCount
    },
    homeDefuseBomb() {
      const count = this.gameInfo.away.team && this.gameInfo.home.team.defuse_bomb || 0
      return count - 0
    },
    awayDefuseBomb () {
      const count = this.gameInfo.away.team && this.gameInfo.away.team.defuse_bomb || 0
      return count - 0
    },
    defuseBombCount () {
      return this.homeDefuseBomb + this.awayDefuseBomb
    },
    homeDefuseBombRange () {
      if (this.defuseBombCount < 1) {
        return 0
      }
      return this.homeDefuseBomb / this.defuseBombCount
    },
    awayDefuseBombRange () {
      if (this.defuseBombCount < 1) {
        return 0
      }
      return this.awayDefuseBomb / this.defuseBombCount
    }
  }
}
</script>

<style lang="less" scoped>
.home-red-team-color {
  background: linear-gradient(90deg, #78EFF9 0%, #7179FF 100%);
}
.away-red-team-color {
  background: linear-gradient(270deg, #78EFF9 0%, #7179FF 100%);
}
.home-blue-team-color {
  background: linear-gradient(90deg, #F2EEB6 0%, #A06B45 100%);
}
.away-blue-team-color {
  background: linear-gradient(270deg, #F2EEB6 0%, #A06B45 100%);
}

.game-info {
  height: 134px;
  background: #2B2B2B;
  .team-vs-score {
    display: flex;
    gap: 9px;
    align-items: center;
    padding-top: 13px;
    .time {
      width: 56px;
      text-align: center;
      font-size: 14px;
      color: #FDFDFA;
    }
    .home, .away {
      flex: 1;
      display: flex;
      justify-content: space-between;
      .team-line {
        width: 150px;
        height: 54px;
        position: relative;
        justify-content: center;
        align-items: center;
        display: flex;
        &.home-red {
          &::before {
            position: absolute;
            content: '';
            left: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #3E89FF;
          }
          background: linear-gradient(-90deg, rgba(47,103,191,0) 0%, rgba(0,93,238,0.65) 100%);
        }
        &.home-blue {
          &::before {
            position: absolute;
            content: '';
            left: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #FFC242;
          }
          background: linear-gradient(-90deg, rgba(47,103,191,0) 0%, rgba(255,173,0,0.65) 100%);
        }
        &.away-red {
          &::before {
            position: absolute;
            content: '';
            right: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #3E89FF;
          }
          background: linear-gradient(90deg, rgba(47,103,191,0) 0%, rgba(0,93,238,0.65) 100%);
        }
        &.away-blue {
          &::before {
            position: absolute;
            content: '';
            right: 0;
            height: 100%;
            top: 0;
            width: 10px;
            background: #FFC242;
          }
          background: linear-gradient(90deg, rgba(47,103,191,0) 0%, rgba(255,173,0,0.65) 100%);
        }
      }
      .logo {
        display: flex;
        align-items: center;
        img {
          width: 38px;
          height: 38px;
          border-radius: 4px;
          background: #fff;
          padding: 2px;
        }
      }
      .score-wrap {
        display: flex;
        align-items: center;
        gap: 5px;
        .money {
          display: flex;
          gap: 4px;
          img {
            width: 17px;
            height: 17px;
          }
          span {
            font-size: 14px;
            color: #FFA347;
            line-height: 17px;
          }
        }
        .score {
          width: 40px;
          height: 40px;
          border-radius: 5px;
          background: #fff;
          text-align: center;
          line-height: 40px;
          font-size: 26px;
          color: #000;
        }
      }
    }
  }
  .info-detail {
    display: flex;
    margin-top: 13px;
    .left, .right {
      flex: 1;
      .info-item {
        display: flex;
        gap: 5px;
        justify-content: center;
        margin-bottom: 5px;
        .home, .away {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 4px;
          .line {
            width: 100px;
            height: 8px;
            border-radius: 8px;
            position: relative;
            background-color: rgba(204, 204, 204, .5);
            .active {
              position: absolute;
              height: 8px;
              border-radius: 8px;
              top: 0;
            }
          }
          .num {
            font-size: 14px;
            color: #FDFDFA;
          }
        }
        .home {
          justify-content: end;
          .line {
            .active {
              right: 0;
            }
          }
        }
        .away {
          .line {
            .active {
              left: 0;
            }
          }
        }
        .title {
          width: 60px;
          text-align: center;
          line-height: 20px;
          font-size: 14px;
          color: #FDFDFA;
        }
      }
    }
  }
}
</style>